import moment from 'moment';

export const filterNames = {
  period: 'period',
  types: 'types',
  companies: 'companies',
  streets: 'streets',
  houses: 'houses',
  addresses: 'addresses',
  onlyActive: 'onlyActive',
};

export const defaultFilterState = {
  [filterNames.period]: [
    moment().subtract(1, 'month'),
    moment().add(2, 'month'),
  ],
  [filterNames.types]: [],
  [filterNames.companies]: [],
  [filterNames.streets]: [],
  [filterNames.houses]: [],
  [filterNames.addresses]: [],
  [filterNames.onlyActive]: false,
};

export const typeIds = {
  debt: 1,
  info: 2,
  shutdown: 3,
  congratulation: 4,
  advertisement: 5
};

export const internalLink = {
  info: { name: 'info', id: 1 },
  showcase: { name: 'showcase', id: 2 },
  orders: { name: 'orders', id: 3 },
};
